import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetConfigurationHistoryEventsResData } from "./GetConfigurationHistoryEventsResData";

const ENDPOINT = "/security/history";

export class GetConfigurationHistoryEventsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetConfigurationHistoryEventsReqData = null;

    constructor(startDate: Date, endDate: Date) {
        super();
        let params = new GetConfigurationHistoryEventsReqData(startDate, endDate);
        this.params = { ...params };
    }

    public async execute(): Promise<GetConfigurationHistoryEventsResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetConfigurationHistoryEventsResData(res);
    }
}

export class GetConfigurationHistoryEventsReqData {
    startDate: Date;
    endDate: Date;

    constructor(startDate: Date, endDate: Date) {
        this.startDate = startDate;
        this.endDate = endDate;
    }
}
